// extracted by css-extract-rspack-plugin
export default {"saved_filters":"savedFilters-module__saved_filters--OzroG","active":"savedFilters-module__active--mC9TH"};